import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';

import { API_QUERY_KEYS } from 'api';
import { requestExtension } from '../methods';
import { RequestExtensionRequest, RequestExtensionResponse } from '../types';

export const useRequestExtension = (): UseMutationResult<
  RequestExtensionResponse,
  unknown,
  RequestExtensionRequest
> => {
  const queryClient = useQueryClient();
  return useMutation(requestExtension, {
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: [API_QUERY_KEYS.getConsultation] }),
  });
};
